<template>
  <div class="accordion-container">
    <button class="qna-btn" @click="toggle">
      <div class="qna-tit">
        <span class="primary q">Q.</span>
        <slot name="header"></slot>
      </div>
      <div class="toggle-plus" :class="{ active: isOpen }">
        <span></span>
        <span></span>
      </div>
      <!-- <IconPlus class="icon-medium" v-if="!isOpen" />
      <IconMinus class="icon-medium" v-else /> -->
    </button>
    <transition name="accordion">
      <div ref="accordionBodyRef" class="accordion-body" :style="bodyStyle">
        <div class="inr">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, nextTick, computed } from 'vue';

const props = defineProps({
  defaultOpen: {
    type: Boolean,
    default: false,
  },
});

const isOpen = ref(props.defaultOpen);
const accordionBodyRef = ref(null); // DOM 접근을 위한 ref
const currentHeight = ref(props.defaultOpen ? 'auto' : '0px');
const displayStyle = ref(props.defaultOpen ? 'block' : 'none');

// 인라인 스타일 계산
const bodyStyle = computed(() => ({
  height: currentHeight.value,
  display: displayStyle.value,
  overflow: 'hidden',
  transition: 'height 0.3s ease', //  속도
}));

const toggle = async () => {
  const el = accordionBodyRef.value;
  if (!el) return;

  if (!isOpen.value) {
    // 1. 열기 로직
    isOpen.value = true;
    displayStyle.value = 'block';

    // DOM이 그려진 후 실제 높이를 측정하기 위해 nextTick 사용
    await nextTick();
    currentHeight.value = `${el.scrollHeight}px`;
  } else {
    // 2. 닫기 로직
    // 현재 scrollHeight를 한 번 더 찍어주어야 0으로 갈 때 애니메이션 시작
    currentHeight.value = `${el.scrollHeight}px`;

    // 브라우저가 높이 변화를 인지할 시간을 준 뒤 0으로 변경
    requestAnimationFrame(() => {
      currentHeight.value = '0px';
    });

    // 애니메이션이 끝난 후 완전히 숨김
    setTimeout(() => {
      if (!isOpen.value) {
        displayStyle.value = 'none';
      }
    }, 300);
    isOpen.value = false;
  }
};
</script>

<style scoped lang="scss">
.accordion-container {
  width: 100%;
  .qna-btn {
    width: 100%;
    padding: 1.25rem 0;
    border-bottom: 1px solid $color-gray-40;
    word-break: break-all;
    .qna-tit {
      display: flex;
      align-items: center;
      gap: $size-s;
    }
  }
}

button {
  justify-content: space-between !important;
  text-align: left !important;
}

.accordion-body {
  overflow: hidden;
  background: $gray10;
  .inr {
    padding: 2rem 1rem;
  }
}

.toggle-plus {
  position: relative;
  min-width: 16px;
  max-width: 16px;
  min-height: 16px;
  max-height: 16px;
  cursor: pointer;
  span {
    position: absolute;
    background: $color-gray-700;
    transition: transform 0.3s ease;

    &:nth-child(1) {
      top: 50%;
      left: 0;
      width: 100%;
      height: 1.5px;
      transform: translateY(-50%);
    }
    &:nth-child(2) {
      left: 50%;
      top: 0;
      width: 1.5px;
      height: 100%;
      transform: translateX(-50%);
    }
  }
  &.active {
    span {
      &:nth-child(2) {
        transform: rotate(90deg);
      }
    }
  }
}
</style>
